import React from 'react';
import { Map } from 'immutable';
import classNames from 'classnames';

const STATUS_COLORS = Map({
  default: {
    New: 'primary',
    Submitted: 'primary',
    Undefined: 'primary',
    Active: 'success',
    Closed: 'success',
    Complete: 'success',
    Resolved: 'success',
    Delete: 'danger',
    Failed: 'danger',
    Inactive: 'danger',
    Unresolved: 'danger',
    Draft: 'warning',
    Handled: 'warning',
    Paused: 'warning',
  },
});

// Get color for value using given key if provided, then use 'default' statuses,
// and lastly default to 'primary'.
const getColor = (value, type) =>
  STATUS_COLORS.getIn(
    [type || 'default', value],
    type ? STATUS_COLORS.getIn(['default', value], 'primary') : 'primary',
  );

export const StatusBadge = ({
  value,
  type,
  sm,
  lg,
  className,
  color,
  defaultColor = 'primary',
  children,
}) => (
  <span
    className={classNames(
      'badge',
      { 'badge-sm': !!sm, 'badge-lg': !!lg },
      className,
      `badge-${color || getColor(value, type) || defaultColor}`,
    )}
  >
    {typeof children === 'function' ? (
      children(value || 'Unknown')
    ) : (
      <>
        {value || 'Unknown'}
        {children}
      </>
    )}
  </span>
);
